import Cookies from "js-cookie";
import axios from "./config";
import { jwtDecode } from "jwt-decode";

interface DecodedToken {
  emp_id: string;
}

export function getHeader() {
  const token = Cookies.get("token") || "";
  const header = {
    Authorization: token,
  };
  return header;
}

const getUserInfo = () => {
  const token = Cookies.get("token");

  if (!token) {
    throw new Error("Authorization token not found");
  }

  return jwtDecode<DecodedToken>(token);
};

export const getAllSales = async (
  page: number,
  size: number,
  params: any
): Promise<any> => {
  let url = `/admin/sales-rules?page=${page}&size=${size}`;
  const response = await axios.post<any>(url, params, {
    headers: getHeader(),
  });
  return response.data;
};


export const getSpecificSales = async (
  id: string,
): Promise<any> => {
  let url = `admin/sales-rules/${id}`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};

export const updateSales = async (
  formData: any,
  id: string
): Promise<any> => {
  const url = `/admin/sales-rules/${id}`;

  const cleanedPayload = Object.fromEntries(
    Object.entries(formData).filter(([_, v]) => v !== undefined)
  );
  

  const response = await axios.put(url, cleanedPayload, {
    headers: {
      ...getHeader(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};
export const addNewSales = async (formData: any): Promise<any> => {
  let url = `/admin/sales-rules/create`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

// export const getAllSales = async (
//     page: number,
//     size: number,
//     params: any
//   ): Promise<any> => {
//     let url = "";
//     if (params.search)
//       url = `/admin/sales-rules?page=${page}&size=${size}&sales_office_ids=${params.search}`;
//     else url = `/admin/sales-rules?page=${page}&size=${size}`;
//     const response = await axios.post<any>(url, {
//       headers: getHeader(),
//     });
//     return response.data;
//   };
